export default __webpack_public_path__ + "static/media/noRecords.10b424e5.svg";